export const getDaysLeft = (endAt) => {
  const now = new Date();
  const end = new Date(endAt);
  if (end < now) {
    return 0;
  }
  const diff = end.getTime() - now.getTime();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

export const isClosingSoon = (endAt) => {
  if (!endAt) {
    return false;
  }
  const now = new Date();
  const end = new Date(endAt);
  if (end < now) {
    return false;
  }
  const weekStart = new Date(now);
  const dayOfWeek = weekStart.getDay();
  weekStart.setDate(weekStart.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));
  weekStart.setHours(0, 0, 0, 0);

  const nextWeekEnd = new Date(weekStart);
  nextWeekEnd.setDate(nextWeekEnd.getDate() + 14);

  return end < nextWeekEnd;
}